import { FC } from 'react';

import { GraphQLQuery } from '../../types';

import styles from './GraphQLQueryData.module.css';

type Props = {
  query: GraphQLQuery;
};

const GraphQLQueryData: FC<Props> = ({ query }) => (
  <pre className={styles.root}>
    {JSON.stringify(query.response.data, undefined, 2)}
  </pre>
);

export default GraphQLQueryData;
